import React from "react";
import { useConstants } from "../../constant/constantProvider";
import "./ProgressSteps.css";

export default function ProgressSteps({ steps, isActive }) {
  const { PROCESSING } = useConstants();

  if (!steps || !steps.length) return null;

  return (
    <div className="progress-steps-container">
      <div className="progress-steps-header">
        <span className="css-sparkles" />
        <span className="progress-steps-title">
          {PROCESSING || "Processing"}
        </span>
      </div>

      <div className="progress-steps-list">
        {steps.map((stepItem, i) => {
          const isObject = typeof stepItem === "object" && stepItem !== null;
          const step = isObject ? stepItem.label : stepItem;
          const isLast = i === steps.length - 1;
          const isDone = isObject ? (stepItem.status === "done" || !isActive) : (!isLast || !isActive);
          const hasConnector = i < steps.length - 1;

          return (
            <div key={i} className="progress-step-item">
              <div className="progress-step-icon-col">
                <div className="progress-step-icon-wrapper">
                  {isDone ? (
                    <div className="progress-step-icon-done">
                      <span className="css-check">✓</span>
                    </div>
                  ) : (
                    <div className="progress-step-icon-active">
                      <div className="css-loader" />
                    </div>
                  )}
                </div>
                {hasConnector && (
                  <div className="progress-step-connector" />
                )}
              </div>

              <div className="progress-step-content">
                <span
                  className={`progress-step-text ${
                    isDone ? "is-done" : "is-active"
                  }`}
                >
                  {step}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
